const recipesSearchData=[
    {
        imgUrl : "https://blog.myfitnesspal.com/wp-content/uploads/2021/03/MFP-Spring-Chicken-Asparagus-Skillet-Featured-480x380.jpg",
        title : "Spring Chicken & Asparagus Skillet",
        by : "BY MYFITNESSPAL'S RECIPES ON MAR 15, 2022",
        description : "This easy one-dish meal offers the best of spring produce alongside chicken cutlets — verdant asparagus, creamy fingerling potatoes, nutty artichoke hearts, and peppy tarragon. To make prep simpler, we use frozen..."
    },
    {
        imgUrl : "https://blog.myfitnesspal.com/wp-content/uploads/2018/03/instant-pot-480x380.jpg",
        title : "Instant Pot Rotini With Chicken and Bell Peppers",
        by : "BY MYFITNESSPAL'S RECIPES ON FEB 22, 2022",
        description : "Use your Instant Pot to put together this whole-grain pasta meal in just 35 minutes from start to finish. For best results, use small (6-ounce) boneless, skinless chicken breasts or cut large chicken breasts horizontally..."
    },
    {
        imgUrl : "https://blog.myfitnesspal.com/wp-content/uploads/2018/10/Chicken-and-Zucchini-Enchiladas-480x380.jpg",
        title : "Chicken and Zucchini Enchiladas",
        by : "BY MYFITNESSPAL’S RECIPES ON NOV 02, 2021",
        description : "These lightened-up enchiladas are the perfect dish to make while we’re transitioning from summer to fall. The fresh corn and zucchini are still in season, but the enchiladas are hearty and satisfying enough for a chilly..."
    },
    {
        imgUrl : "https://blog.myfitnesspal.com/wp-content/uploads/2020/03/Veggie-Loaded-Skillet-Chicken-Pot-Pie-480x380.jpg",
        title : "Veggie-Loaded Skillet Chicken Pot Pie",
        by : "BY MYFITNESSPAL’S RECIPES ON OCT 19, 2021",
        description : "In fewer than 30 minutes, you can be sitting down to a saucy, homemade chicken pot pie. The trick is to cook the crust on a baking sheet in the oven while the filling comes together in a skillet on the stovetop; then simply..."
    },
    {
        imgUrl : "https://blog.myfitnesspal.com/wp-content/uploads/2020/02/Slow-Cooker-Ratatouille-Chicken-480x380.jpg",
        title : "Slow Cooker Chicken Ratatouille",
        by : "BY MYFITNESSPAL’S RECIPES ON OCT 05, 2021",
        description : "This easy slow cooker chicken recipe will be a go to. The eggplant is best when cooked to complete, melting tenderness, and the slow cooker does a wonderful job of it, melding the eggplant and vegetables with piney rosemary..."
    },
    {
        imgUrl : "https://blog.myfitnesspal.com/wp-content/uploads/2021/03/MFP-Spring-Fish-Chowder-Featured-480x380.jpg",
        title : "Spring Fish Chowder",
        by : "BY MYFITNESSPAL’S RECIPES ON MAR 22, 2022",
        description : "Full of leeks, baby potatoes, green peas and baby carrots, this lighter take on chowder is perfect for spring. You can also mix up the seafood depending on your preferences and tastes; coarsely chopped shrimp works well..."
    },
    {
        imgUrl : "https://blog.myfitnesspal.com/wp-content/uploads/2021/01/MFP-Fish-and-Shrimp-Chowder-Featured-1-480x380.jpg",
        title : "Lactose-Free Fish and Shrimp Chowder",
        by : "BY MYFITNESSPAL’S RECIPES ON JAN 15, 2021",
        description : "If you’re lactose intolerant, a creamy chowder is obviously a no-no. Not so with this recipe. We replace the usual butter with heart-healthy olive oil and use widely available lactose-free 2% milk for heavy cream and milk...."
    },
    {
        imgUrl : "https://blog.myfitnesspal.com/wp-content/uploads/2014/07/mahi-mahi-tacos-480x380.jpg",
        title : "Simple Fish Tacos with Corn & Tomato Salsa",
        by : "BY COOK SMARTS ON JUL 17, 2015",
        description : "Get your omega-3 on! These Mahi Mahi Tacos with Corn & Tomato Salsa from Cook Smarts features an amazing yet simple spice blend seasoning. The fish is oven baked, making this meal super quick and..."
    },
    {
        imgUrl : "https://blog.myfitnesspal.com/wp-content/uploads/2014/08/Grilled-Fish-Tacos-With-Dijon-Cabbage-Cole-Slaw-480x380.jpg",
        title : "Grilled Fish Tacos & Honey Dijon Cabbage Slaw",
        by : "BY MYFITNESSPAL'S FEATURED RECIPES ON MAY 22, 2015",
        description : "Eating Bird Food’s Grilled Fish Tacos & Honey Dijon Cabbage Slaw are a taste of summer, and will surely satisfy  with over 16 grams of protein per taco. Known for its anti-inflammatory and protective properties, we..."
    },
    {
        imgUrl : "https://blog.myfitnesspal.com/wp-content/uploads/2020/05/Dijon-Chickpea-and-Egg-Salad-480x380.jpg",
        title : "Dijon Chickpea and Egg Salad",
        by : "BY MYFITNESSPAL’S RECIPES ON AUG 03, 2021",
        description : "Made from mostly pantry and fridge staples, this versatile salad is a great option for easy lunches. It has the satisfying richness of egg salad but is lightened up with smashed chickpeas. Dijon mustard and briny capers..."
    },
    {
        imgUrl : "https://blog.myfitnesspal.com/wp-content/uploads/2021/02/MFP-Breakfast-Burrito-Bowls-Featured-480x380.jpg",
        title : "13 Easy Egg Recipes for Busy Mornings Under 370 Calories",
        by : "BY MYFITNESSPAL’S RECIPES ON APR 12, 2021",
        description : "Eggs are a nutrient-dense, complete protein and a great addition to any morning meal. From breakfast tacos to make-ahead sandwiches and quiche, these 13 recipes are ideal for busy mornings and clock in under 370 calories..."
    },
    {
        imgUrl : "https://blog.myfitnesspal.com/wp-content/uploads/2021/03/MFP-Fried-Egg-and-Avocado-Bowl-Featured-480x380.jpg",
        title : "Fried Egg and Avocado Breakfast Bowls",
        by : "BY MYFITNESSPAL’S RECIPES ON MAR 19, 2021",
        description : "To make this stunning breakfast bowl an any-morning reality, we cook our whole grains in advance and store them in individual portions in our fridge or freezer. Defrost what you need and the rest of this meal comes..."
    },
    {
        imgUrl : "https://blog.myfitnesspal.com/wp-content/uploads/2020/05/Use-What-You-Have-Crustless-Quiche-480x380.jpg",
        title : "10 Most Popular Egg Recipes of 2020",
        by : "BY MYFITNESSPAL’S RECIPES ON DEC 28, 2020",
        description : "Packed with protein, iron, magnesium and vitamins A and D — eggs are a weight-loss staple. They’re also extremely versatile and easy to use in everything from breakfast casseroles and omelets to sandwiches and grain..."
    },
    {
        imgUrl : "https://blog.myfitnesspal.com/wp-content/uploads/2020/10/Air-Fryer-Egg-Rolls-480x380.jpg",
        title : "Air Fryer Egg Rolls",
        by : "BY MYFITNESSPAL’S RECIPES ON OCT 30, 2020",
        description : "If you’ve been disappointed by baked egg rolls before, be prepared to be delighted by air-fried ones. The dry, constantly circulating air gives the wrapper a shatteringly crisp texture. If you can, aim for vegan egg roll..."
    },
    {
        imgUrl : "https://blog.myfitnesspal.com/wp-content/uploads/2020/12/Vegan-Apple-Crumb-Coffee-Cake-480x380.jpg",
        title : "Vegan Apple Crumb Coffee Cake",
        by : "BY MYFITNESSPAL’S RECIPES ON DEC 07, 2021",
        description : "Heart-healthy olive oil, apple cider and grated apple make this dairy- and egg-free spice cake super moist. Buy fresh apple cider with no-added sugar for this recipe; look for it where refrigerated juices are sold. The..."
    },
    {
        imgUrl : "https://blog.myfitnesspal.com/wp-content/uploads/2021/01/MFP-Apple-Tartlets-Featured-480x380.jpg",
        title : "Apple Tartlets in Phyllo Nests",
        by : "BY MYFITNESSPAL’S RECIPES ON OCT 19, 2021",
        description : "These little pies are a showstopper, with a crunchy golden nest of phyllo, filled with tender, cinnamon-laced apples, topped with a dollop of vanilla yogurt. Buy full-sized sheets of phyllo, or if you buy the package with..."
    },
    {
        imgUrl : "https://blog.myfitnesspal.com/wp-content/uploads/2019/11/Seared-Pork-Chops-With-Apple-Fennel-Slaw-480x380.jpg",
        title : "Seared Pork Chops With Apple-Fennel Slaw",
        by : "BY MYFITNESSPAL’S RECIPES ON OCT 12, 2021",
        description : "Come fall, one of our favorite flavor combinations is apple, fennel and celery. Together they are bright, crunchy, fresh and have just the right amount of sweetness. In this dish, we turn the magical trifecta into a creamy..."
    },
    {
        imgUrl : "https://blog.myfitnesspal.com/wp-content/uploads/2020/11/MFP-Cinnamon-Pancakes-FEATURED-480x380.jpg",
        title : "Whole-Grain Cinnamon-Apple Pancakes",
        by : "BY MYFITNESSPAL’S RECIPES ON OCT 12, 2021",
        description : "These hearty pancakes combine oats and white whole-wheat flour for 100% whole-grain goodness. They cook up fluffy, yet somehow maintain a beguiling creamy texture inside. A little shredded apple goes into the batter for..."
    },
    {
        imgUrl : "https://blog.myfitnesspal.com/wp-content/uploads/2018/10/Apple-Pie-Energy-Bites-480x380.jpg",
        title : "Apple Pie Energy Bites",
        by : "BY MYFITNESSPAL'S RECIPES ON SEP 21, 2021",
        description : "These nutrient-dense treats are packed with dried apples, toasted nuts, oats and cinnamon. They’re a great balanced snack with fiber, protein, healthy fats and whole grains — and they taste like portable apple pies...."
    }
    
]

export {recipesSearchData}